import { Building2 } from "lucide-react";

const fmtN = (n) => Number(n || 0).toLocaleString("en-US");

export const BranchTotals = ({ items = [], summary, branch, setBranch }) => {
  if (!items.length || (items.length === 1 && !items[0].branch)) return null;
  const card = (key, label, s, testid) => {
    const on = branch === key;
    return (
      <button key={key} type="button" onClick={() => setBranch(on && key !== "all" ? "all" : key)} data-testid={testid}
        className={`min-w-[170px] shrink-0 rounded-xl border p-3 text-start transition-colors ${on ? "border-blue-600 bg-blue-50" : "border-slate-200 bg-white hover:border-blue-300"}`}>
        <p className="flex items-center gap-1.5 truncate text-xs font-semibold text-slate-600"><Building2 className="h-3.5 w-3.5 shrink-0" />{label}</p>
        <p className="mt-1 font-heading text-2xl font-extrabold text-slate-900 font-mono-nums">{fmtN(s.completed)}</p>
        <p className="text-[11px] text-slate-500">طلب مكتمل · {fmtN(s.riders)} مندوب{s.attendance != null ? ` · حضور ${s.attendance}%` : ""}</p>
      </button>
    );
  };
  const total = items.reduce((a, b) => ({ completed: a.completed + (b.completed || 0), riders: a.riders + (b.riders || 0), w: a.w + (b.attendance || 0) * (b.riders || 0) }), { completed: 0, riders: 0, w: 0 });
  return (
    <div className="flex gap-2 overflow-x-auto pb-1" data-testid="riders-branch-totals">
      {card("all", "إجمالي كل الفروع", { ...total, attendance: total.riders ? Math.round((total.w / total.riders) * 10) / 10 : null }, "branch-total-all")}
      {items.map((b) => card(b.branch || "__none__", b.branch || "بدون فرع", b, `branch-total-${b.branch || "none"}`))}
    </div>
  );
};
